// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal{padding-top:20vh}.modal-backdrop{display:none}.button-remove:disabled{cursor:wait}", ""]);
// Exports
module.exports = exports;
